import script from "./opdPrescription.vue?vue&type=script&setup=true&lang=js"
export * from "./opdPrescription.vue?vue&type=script&setup=true&lang=js"

import "./opdPrescription.vue?vue&type=style&index=0&id=68def124&scoped=true&lang=css"

import exportComponent from "F:\\proj-abhinav\\meraki\\patient-portal-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68def124"]])

export default __exports__